import AddExercise from "../pages/exercises/add-exercise";
import DashboardPageLayout from "../layouts/dashboard_layout";
import { ProtectedRoutes } from "./protected_route";

const ExerciseRoutes = {
    path: "/exercises",
    element: (
        <ProtectedRoutes>
            <DashboardPageLayout />
        </ProtectedRoutes>
    ),
    children: [
        {
            path: "add-exercise",
            element: <AddExercise />,
        },
    ],
};

export default ExerciseRoutes;
